import * as selectors from './selectors'
import reducer from './reducer'

export { selectors }
export const { toggleMenu } = reducer.actions
export default reducer
